/**
 * La cabecera de «Nueva campaña» (DISENO §5 a §8): los cuatro pasos, con el actual marcado. Un paso al que todavía no
 * se puede ir (Grupos antes de segmentar, Mensajes antes de tener los grupos con nombre) se ve apagado. Envío no tiene
 * pantalla propia: se prepara al pie de Mensajes, así que se ve sin link.
 */

import { Link } from "react-router-dom";

export { Antetitulo } from "../../../components/activa/Pagina";

const PASOS = ["Segmentar", "Grupos", "Mensajes", "Envío"] as const;

export function PasosCampana({ actual, rutas }: { actual: 0 | 1 | 2; rutas: [string | null, string | null, string | null] }) {
  return (
    <ol aria-label="Pasos de la campaña" className="flex gap-1.5 overflow-x-auto sm:flex-wrap sm:gap-2">
      {PASOS.map((p, i) => {
        const ruta = i < 3 ? rutas[i] : null;
        // un paso sin a dónde ir (Grupos antes de segmentar, Mensajes sin grupos con nombre, Envío) se ve apagado
        const clase = `inline-flex min-h-[36px] items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1.5 text-xs font-semibold sm:px-3 sm:text-sm ${
          i === actual ? "bg-violet-600 text-white" : ruta ? "bg-violet-50 text-violet-700" : "bg-slate-100 text-slate-400"
        }`;
        const cuerpo = (
          <>
            <span className="font-mono text-xs">{i + 1}</span> · {p}
          </>
        );
        return (
          <li key={p} aria-current={i === actual ? "step" : undefined}>
            {ruta && i !== actual ? (
              <Link to={ruta} className={`${clase} hover:bg-violet-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-400`}>
                {cuerpo}
              </Link>
            ) : (
              <span className={clase}>{cuerpo}</span>
            )}
          </li>
        );
      })}
    </ol>
  );
}

export const btnPrimario =
  "min-h-[44px] px-5 rounded-xl bg-violet-600 text-white text-sm font-semibold hover:bg-violet-700 inline-flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-400";
export const btnSecundario =
  "min-h-[44px] px-5 rounded-xl border border-slate-200 bg-white text-sm font-semibold text-slate-800 hover:bg-slate-50 inline-flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-400";
